export default __webpack_public_path__ + "static/media/Group 1558.f708f512.png";